var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8a.5.5 0 1 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 17V3A1.5 1.5 0 0 1 2 1.5h9a.5.5 0 1 1 0 1H2a.5.5 0 0 0-.5.5v14a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5V8zm-.37-6.369l-8.982 8.982-.55 1.964 1.964-.55 8.982-8.982-1.414-1.414zm.707-.707l1.414 1.414a1 1 0 0 1 0 1.414L9.27 12.734a1 1 0 0 1-.437.256l-1.964.55a1 1 0 0 1-1.233-1.233l.55-1.964a1 1 0 0 1 .256-.437L15.423.924a1 1 0 0 1 1.414 0z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquareIcon);
export default __webpack_public_path__ + "static/media/edit-square-icon.8584fe7267ec99db19851bf07f8cba9a.svg";
export { ForwardRef as ReactComponent };